






import { Vue, Component } from "@/shared/vuepack";

@Component
export default class Home extends Vue {
}
